import Vue from 'vue';
import string from 'lodash/string';
import webcall from '@/libs/webcall';
import SUBMISSION_STATUS from '@/assets/data/viddsee/submissionStatus';

const unescapeData = (jsonObject) => {
  const processedData = {};
  Object.keys(jsonObject)
    .forEach((key) => {
      const value = jsonObject[key];
      if (typeof value === 'string') {
        processedData[key] = string.unescape(jsonObject[key]);
      } else {
        processedData[key] = jsonObject[key];
      }
    });
  return processedData;
};

const addPreSubmissionTreatment = submission => ({
  // A non-string value will cause render issue on vs-admin side.
  // TODO: Remove this after if vs-admin resolve this issue.
  festivals: submission.festivals || '',
});

export default {
  namespaced: true,
  state: {},
  getters: {
    list(state) {
      const submissions = Object.keys(state)
        .map(submissionId => state[submissionId]);
      const result = [];
      submissions.forEach((submission) => {
        const index = SUBMISSION_STATUS.TYPE[submission.status];
        if (!result[index]) result[index] = [];
        result[index].push(submission);
      });
      // Sort the data first by updated time
      return result.map(videos => videos.sort((a, b) => ((a.updated_at > b.updated_at) ? -1 : 1)));
    },
  },
  // Local Mutation - to be performed after remote
  mutations: {
    add(state, data) {
      const processedData = unescapeData(data);
      Vue.set(state, data.id, processedData);
    },
    update(state, data) {
      const processedData = unescapeData(data);
      Vue.set(state, data.id, {
        ...state[data.id],
        ...processedData, // Update by override existing fields
      });
    },
    remove(state, data) {
      Vue.delete(state, data.id);
    },
  },
  // Remote + Local Mutation
  actions: {
    create({ state, commit }) {
      return webcall.submission.new()
        .then(({ data }) => {
          commit('add', data);
          return data;
        });
    },
    list({ state, commit, getters }) {
      return webcall.dashboard.list({
        params: {
          per_page: 999,
          current_page: 0,
        },
      })
        .then(({ data }) => {
          data.videos.forEach(video => commit('add', video));
          return getters.list;
        });
    },
    get({ state, commit, getters }, submissionId) {
      return webcall.submission.get(submissionId)
        .then(({ data }) => {
          commit('add', data);
          return data;
        });
    },
    remove({ state, commit }, submission) {
      return webcall.submission.delete(submission.id)
        .then(() => commit('remove', submission));
    },
    update({ state, commit, getters }, submission) {
      // TODO: Implement error notification / fallback
      //       Make sure a failed update does not erase user's local change
      return webcall.submission.update(submission.id, submission)
        .then(({ data }) => commit('update', data));
    },
    submit({ state, commit, getters }, submission) {
      const currentStatus = SUBMISSION_STATUS.TYPE[submission.status];
      if (currentStatus <= SUBMISSION_STATUS.TYPE.incomplete) {
        return webcall.submission.update(submission.id, {
          ...addPreSubmissionTreatment(submission),
          status: 'pending',
        });
      } else {
        return Promise.resolve();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/submission.js